export default {
  unlocked_plural: '{{count}} oferte au fost deblocate',
  unlocked: 'Oferta {{offer}} a fost deblocată',
  removed_one: 'Oferta {{offer}} a fost eliminată',
  removed_few: '{{count}} au fost eliminate',
  removed_other: '{{count}} au fost eliminate',
};
